import {
  MorphemeTilePresentationProvider,
  useMorphemeTilePresentation,
} from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.tile.ui.presentation";
import type React from "react";
import type { GraphemeGlyph } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.entities";
import { useQuery } from "@-/com.npmjs.tanstack__react-query";
import { useInfoGraphemeMorphemeSliceQueryOptions } from "@-/dev.improve.haniverse.lib.morpheme.read";
import { GraphemeSvgGlyph } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.grapheme.glyph.svg";

/** Mounted only in debug SVG mode, so normal tiles never subscribe to stroke queries. */
function MorphemeTileSvgGlyph({
  fallback,
  glyph,
  size,
}: {
  fallback: React.ReactNode;
  glyph: GraphemeGlyph;
  size: number;
}) {
  const options = useInfoGraphemeMorphemeSliceQueryOptions(glyph.display);
  const { data } = useQuery(options);
  if (!data?.graphemeStrokes?.length) {
    return fallback;
  }
  return (
    <GraphemeSvgGlyph
      fallback={fallback}
      glyph={glyph}
      showBackground={false}
      size={size}
      strokeList={data?.graphemeStrokes ?? null}
    />
  );
}

function MorphemeTileGlyphContent(props: React.ComponentProps<typeof MorphemeTileSvgGlyph>) {
  const { svgTileGlyphsEnabled } = useMorphemeTilePresentation();
  return svgTileGlyphsEnabled ? <MorphemeTileSvgGlyph {...props} /> : props.fallback;
}

/** Shared renderer override for standalone mnemonic tabs and detail tiles. */
export function MorphemeTileGlyph(props: React.ComponentProps<typeof MorphemeTileSvgGlyph>) {
  return (
    <MorphemeTilePresentationProvider>
      <MorphemeTileGlyphContent {...props} />
    </MorphemeTilePresentationProvider>
  );
}
